module.exports = __webpack_public_path__ + "img/Applet.9c917b64.png";